import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        items: [],
        unreadCount: 0,
        pagination: { page: 1, limit: 20, total: 0, pages: 1 },
    },
    reducers: {
        setNotifications(state, action) {
            const { notifications, pagination, unreadCount } = action.payload;
            state.items = notifications;
            state.pagination = pagination;
            state.unreadCount = unreadCount;
        },
        appendNotifications(state, action) {
            const { notifications, pagination, unreadCount } = action.payload;
            state.items = [...state.items, ...notifications];
            state.pagination = pagination;
            state.unreadCount = unreadCount;
        },
        addNotification(state, action) {
            state.items = [action.payload, ...state.items];
            state.unreadCount += 1;
        },
        updateNotificationRead(state, action) {
            const item = state.items.find(n => n._id === action.payload.id);
            if (item && !item.read) {
                item.read = true;
                item.readAt = new Date().toISOString();
                state.unreadCount = Math.max(0, state.unreadCount - 1);
            }
        },
        removeNotification(state, action) {
            const item = state.items.find(n => n._id === action.payload.id);
            if (item && !item.read) {
                state.unreadCount = Math.max(0, state.unreadCount - 1);
            }
            state.items = state.items.filter(n => n._id !== action.payload.id);
        },
        setAllRead(state) {
            state.items = state.items.map(n => ({ ...n, read: true }));
            state.unreadCount = 0;
        },
        setUnreadCount(state, action) {
            state.unreadCount = action.payload.count;
        },
    },
});

export const {
    setNotifications,
    appendNotifications,
    addNotification,
    updateNotificationRead,
    removeNotification,
    setAllRead,
    setUnreadCount,
} = notificationSlice.actions;

export default notificationSlice.reducer;
